export const formatSortOptions = (options = []) => {
  return options.map(({ id, name, value }) => ({
    label: name,
    value,
    id,
  }));
};
